import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import {
    MemberSearchInput,
    MemberSearchText,
} from '../../styles/TextStyles';
import { BaseButton } from "../../styles/ButtonStyles";
import Loader from "../Loader";
import urls from "../../api/urls.json";
import { FlexWrapper, } from "../../styles/WrapperStyles";
import ListModal from '../modals/ListModal';
import { authorizedHttpGet } from '../../api/httpCalls';
import LeftNav from "../LeftNav";
import { useLocation, useNavigate } from "react-router-dom";
import '../styles/Member.css';

const Par = styled.div`
  display: flex;
  width: 100%;
  height: max-content;
  marggin-left: 200px
`;

const RightDiv = styled.div`
  padding: 0px 20px;
  height: max-content;
  border-radius: 30px;
  background-color: #f8f8fa;
  display: flex;
`;

const TableDiv = styled.table`
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;

`;

const TableRow = styled.tr`
    background-color: #f8f8fa;
    border: 1px solid #000000;
    text-align: left;
    padding: 8px;
    &:nth-child(even) {
        background-color: #dddddd;
      };
`;

const TableData = styled.td`
    border: 1px solid #000000;
    text-align: left;
    padding: 8px;
`;

const TableHeader = styled.th`
    background-color: #dddddd;
    border: 1px solid #000000;
    text-align: left;
    padding: 8px;
`;

const MemberSearchTextChild = styled(MemberSearchText)`
padding-top: 20px;
`;

const MemberSearchInputChild = styled(MemberSearchInput)`
margin-top: 17px;
`;

const ToggleRow = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
    margin: 10px 0 16px;
`;

const ToggleButton = styled.button`
    border: 1px solid ${props => props.active ? '#2f6fed' : '#cfd8e3'};
    background: ${props => props.active ? '#e8f0ff' : '#ffffff'};
    color: ${props => props.active ? '#2f6fed' : '#344054'};
    border-radius: 10px;
    padding: 8px 14px;
    cursor: pointer;
    font-weight: 600;
`;


const PhoneNumber = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const authToken = localStorage.getItem('authToken');
    const isOtpVerified = localStorage.getItem('verificationPassed');
    if (!authToken || !isOtpVerified) {
        sessionStorage.setItem('redirectUrl', location.pathname)
        navigate('/login')
    }
    const [appName, setAppName] = useState(localStorage.getItem('appName'));
    const [phone, setPhone] = useState('');
    const [phone_code, setPhoneCode] = useState('');
    const [dropDownValues, setDropDownValues] = useState({});
    const [listItem, setListItem] = useState('');
    const [loading, setLoading] = useState(false);
    const [otpData, setOtpData] = useState([]);
    const [displayModal, setDisplayModal] = useState(false);
    const [showBlockedOtp, setShowBlockedOtp] = useState(false);
    const apiPageChange = React.useRef(1);
    const totalPagesApi = React.useRef(1);

    const resetSearch = () => {
        setPhone('');
        setPhoneCode('');
        totalPagesApi.current = 1;
        apiPageChange.current = 1;
    }

    const handleLeftNavAppChange = (name) => {
        resetSearch();
        setAppName(name)
    };

    useEffect(() => {
        resetSearch();
    }, [appName]);

    const getDropDownValues = async () => {
        setLoading(true);
        let response = await authorizedHttpGet(urls.GET_PHONECODES);
        if (response.status) {
            setDropDownValues(response.data);
        }
        setLoading(false);
    }

    useEffect(() => {
        getDropDownValues();
    }, [appName]);

    const getListItem = () => {
        if (listItem === 'phone_code') {
            return dropDownValues.phonecodes;
        }
    }

    const itemSelected = (item) => {
        if (listItem === 'phone_code') {
            setPhoneCode(item.value);
        }
        closeModal();
    }


    const handleDropDownChange = (item) => {
        setListItem(item);
        setDisplayModal(true);
    }

    const closeModal = () => {
        setDisplayModal(false);
    }

    const fetchData = async (blockedOtp = showBlockedOtp) => {
        setLoading(true);
        let response = await authorizedHttpGet(urls.GET_OTP_BY_PHONENUMBER, {
            page: apiPageChange.current,
            items_per_page: 50,
            phonecode: phone_code,
            phone_number: phone,
            app_name: appName,
            blocked_otp: blockedOtp
        });
        if (response.status) {
            setOtpData(response.data)
        }
        setLoading(false);
    }

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.key === 'Enter') {
                fetchData();
            }
        };
        document.addEventListener('keydown', handleKeyPress);
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    });

    return (
        <div className='App'>
            <LeftNav handleLeftNavAppChange={handleLeftNavAppChange} tabName={'Phone Numbers'} />
            <Par className='marginLeft200'>
                {loading && <Loader loading={loading} />}
                {displayModal && <ListModal closeModal={closeModal} list={getListItem(listItem)} itemSelected={itemSelected} />}
                <div className='width100'>
                    <FlexWrapper className='marginTop25'>
                        <RightDiv>
                            <MemberSearchTextChild>Phone Code</MemberSearchTextChild>
                            <MemberSearchInputChild readOnly value={phone_code} onClick={() => handleDropDownChange('phone_code')} />
                            <MemberSearchTextChild>Phone Number</MemberSearchTextChild>
                            <MemberSearchInputChild value={phone} onChange={(e) => setPhone(e.target.value)} />
                            <div>
                                <BaseButton onClick={() => fetchData()}>Search</BaseButton>
                            </div>
                            <ToggleRow>
                                <ToggleButton type="button" active={!showBlockedOtp} onClick={() => {
                                    setShowBlockedOtp(false);
                                    fetchData(false);
                                }}>
                                    OTP Logs
                                </ToggleButton>
                                <ToggleButton type="button" active={showBlockedOtp} onClick={() => {
                                    setShowBlockedOtp(true);
                                    fetchData(true);
                                }}>
                                    Blocked OTP
                                </ToggleButton>
                            </ToggleRow>
                        </RightDiv>
                    </FlexWrapper>
                    <TableDiv>
                        <thead>
                            <TableRow>
                                <TableHeader>Phone Number</TableHeader>
                                <TableHeader>App</TableHeader>
                                {showBlockedOtp ? (
                                    <>
                                        <TableHeader>Created At</TableHeader>
                                        <TableHeader>ASN</TableHeader>
                                        <TableHeader>Organization Name</TableHeader>
                                    </>
                                ) : (
                                    <>
                                        <TableHeader>IP Address</TableHeader>
                                        <TableHeader>ASN</TableHeader>
                                        <TableHeader>Organization Name</TableHeader>
                                        <TableHeader>Service Provider</TableHeader>
                                        <TableHeader>Country</TableHeader>
                                        <TableHeader>Status</TableHeader>
                                        <TableHeader>Requested At</TableHeader>
                                        <TableHeader>Delivered At</TableHeader>
                                        <TableHeader>Reason</TableHeader>
                                        <TableHeader>OTP Info</TableHeader>
                                        <TableHeader>OTP Typed</TableHeader>
                                        <TableHeader>Typed Time</TableHeader>
                                    </>
                                )}
                            </TableRow>
                        </thead>
                        <tbody>
                            {otpData.map((phone, index) => (
                                <TableRow key={index}>
                                    <TableData>{phone.phone_number}</TableData>
                                    <TableData>{phone.app}</TableData>
                                    {showBlockedOtp ? (
                                        <>
                                            <TableData>{phone.created_at}</TableData>
                                            <TableData>{phone.asn}</TableData>
                                            <TableData>{phone.org_name}</TableData>
                                        </>
                                    ) : (
                                        <>
                                            <TableData>{phone.ip_address}</TableData>
                                            <TableData>{phone.asn}</TableData>
                                            <TableData>{phone.org_name}</TableData>
                                            <TableData>{phone.provider}</TableData>
                                            <TableData>{phone.country_name}</TableData>
                                            <TableData>{phone.status}</TableData>
                                            <TableData>{phone.created_at}</TableData>
                                            <TableData>{phone.delivery_time}</TableData>
                                            <TableData>{phone.reason}</TableData>
                                            <TableData>{phone.otp_info}</TableData>
                                            <TableData>{phone.otp_typed}</TableData>
                                            <TableData>{phone.otp_typed_time}</TableData>
                                        </>
                                    )}
                                </TableRow>
                            ))}
                        </tbody>
                    </TableDiv>
                </div>
            </Par>
        </div>
    )
};

export default PhoneNumber;
